import { render, staticRenderFns } from "./AnalisaGabungan.vue?vue&type=template&id=a3ef60c6&scoped=true&"
import script from "./AnalisaGabungan.vue?vue&type=script&lang=js&"
export * from "./AnalisaGabungan.vue?vue&type=script&lang=js&"
import style0 from "./AnalisaGabungan.vue?vue&type=style&index=0&id=a3ef60c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ef60c6",
  null
  
)

export default component.exports